import React, { useState, useEffect } from 'react';
import './Navbar.css';
import logo from '../assets/codex-logo.jpg';
import { FaBars, FaTimes } from 'react-icons/fa';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showText, setShowText] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setShowText(true);
      } else {
        setShowText(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className="navbar">
      <div className="logo-container">
        <a href="#home" className="logo-link">
          <img src={logo} alt="Codex Crew Logo" className="logo" />
        </a>
        {showText && (
          <span className="logo-text">
            <span className="codex">Codex</span>
            <span className="crew">Crew</span>
          </span>
        )}
      </div>

      <div className={`nav-links-container ${isOpen ? 'open' : ''}`}>
        <ul className="nav-links">
          <li><a href="#home" onClick={toggleMenu}>Home</a></li>
          <li><a href="#about" onClick={toggleMenu}>About Us</a></li>
          <li><a href="#workshops" onClick={toggleMenu}>Workshops</a></li>
          <li><a href="#codex-crew" onClick={toggleMenu}>Codex Crew</a></li>
          <li><a href="#footer" onClick={toggleMenu}>Contact Us</a></li>
        </ul>
      </div>

      <div className="burger-icon" onClick={toggleMenu}>
        {isOpen ? <FaTimes /> : <FaBars />}
      </div>
    </nav>
  );
};

export default Navbar;
